<template lang="pug">
  #barra-brasil
    ul#menu-barra-temp(style="list-style: none")
      li(style="display:inline; float:left;padding-right:10px; margin-right:10px; border-right:1px solid #EDEDED")
        a(href="http://brasil.gov.br" target="_blank" style="font-family:sans,sans-serif; text-decoration:none; color:white;") Portal do Governo Brasileiro
      //- li
        a(href="http://epwg.governoeletronico.gov.br/barra/atualize.html" style="font-family:sans,sans-serif; text-decoration:none; color:white;") Atualize sua Barra de Governo
</template>

<script>
export default {
  methods: {
    checkOnScroll () {
      let el = document.getElementById('barra-brasil')
      if (window.scrollY > 50) {
        el.classList.add('hide')
      }
      if (window.scrollY < 10) {
        el.classList.remove('hide')
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.checkOnScroll)
  },
  mounted () {
    setTimeout(function () {
      let links = document.getElementById('barra-brasil').getElementsByTagName('a')
      for (let link of links) {
        link.setAttribute('target', '_blank')
      }
      let menu = document.getElementById('menu-icon')
      menu.removeAttribute('target', '_blank')
    }, 1500)
  }
}
</script>

<style lang="scss">
#barra-brasil {
    z-index: 9999;
    @include media("<desktop") {
      position: fixed;
      width: 100%;
      top: 0;
    }

  #wrapper-barra-brasil{
    max-width: 1170px;

    @include media("<1200px") {
      max-width: 970px;
    }
    @include media("<desktop") {
      max-width: 750px;
    }
  }
}

#barra-brasil #brasil-vlibras .logo-vlibras:hover+.link-vlibras, 
#barra-brasil #brasil-vlibras .logo-vlibras:active+.link-vlibras, 
#barra-brasil #brasil-vlibras .logo-vlibras:focus+.link-vlibras, 
#barra-brasil #brasil-vlibras .link-vlibras:hover, 
#barra-brasil #brasil-vlibras .link-vlibras:active, 
#barra-brasil #brasil-vlibras .link-vlibras:focus {
 z-index: 9 !important;
 right: 5px; 
 text-align: center; 
}

#barra-brasil nav:active ul.list, 
#barra-brasil nav:focus ul.list, 
#barra-brasil nav:hover ul.list {
  height: auto !important;
}

#barra-brasil #brasil-vlibras .link-vlibras {
  line-height: 1.6;
  text-align: left;

  a {
    color: inherit;
  }
}

</style>


// WEBPACK FOOTER //
// BarraGoverno.vue?f568aed6